__webpack_require__.p = "https://techminds.pstatic.net/pkgtour/statics/vertical-v2/d80660271a200f87ad74b993da4e3b48f1f4b7d2/_next/";